import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function SnoozeNextWeek(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
          <Path
              d="M11.4223 1.68504H11.7678C12.7119 1.69017 13.6158 2.06749 14.2834 2.73506C14.951 3.40264 15.3283 4.30659 15.3334 5.25067V10.6663C14.8614 10.0381 14.1725 9.58202 13.3779 9.40935V5.25067C13.3779 4.82365 13.2082 4.41412 12.9063 4.11217C12.6043 3.81022 12.1948 3.64059 11.7678 3.64059H4.23238C3.80536 3.64059 3.39583 3.81022 3.09388 4.11217C2.79194 4.41412 2.6223 4.82365 2.6223 5.25067V11.8083C2.62738 12.2337 2.79864 12.6403 3.09949 12.9412C3.40035 13.242 3.80694 13.4133 4.23238 13.4184H9.41852C9.60301 14.2188 10.0758 14.9091 10.7216 15.3739H4.23238C3.2883 15.3688 2.38435 14.9915 1.71677 14.3239C1.0492 13.6563 0.671884 12.7524 0.666748 11.8083V5.25067C0.671884 4.30659 1.0492 3.40264 1.71677 2.73506C2.38435 2.06749 3.2883 1.69017 4.23238 1.68504H4.57786V0.730074C4.57786 0.536446 4.65478 0.350749 4.79169 0.213834C4.92861 0.0769183 5.11431 0 5.30793 0H5.47741C5.67104 0 5.85674 0.0769183 5.99365 0.213834C6.13057 0.350749 6.20749 0.536446 6.20749 0.730074V1.68504H9.79267V0.730074C9.79267 0.536446 9.86959 0.350749 10.0065 0.213834C10.1434 0.0769183 10.3291 0 10.5227 0H10.6922C10.8859 0 11.0716 0.0769183 11.2085 0.213834C11.3454 0.350749 11.4223 0.536446 11.4223 0.730074V1.68504Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M4.72137 4.9443H5.73826C5.99746 4.9443 6.20759 5.15442 6.20759 5.41363V6.43052C6.20759 6.68972 5.99746 6.89985 5.73826 6.89985H4.72137C4.46216 6.89985 4.25203 6.68972 4.25203 6.43052V5.41363C4.25203 5.15442 4.46216 4.9443 4.72137 4.9443Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M8.5086 4.9443H7.49171C7.23251 4.9443 7.02238 5.15442 7.02238 5.41363V6.43052C7.02238 6.68972 7.23251 6.89985 7.49171 6.89985H8.5086C8.76781 6.89985 8.97793 6.68972 8.97793 6.43052V5.41363C8.97793 5.15442 8.76781 4.9443 8.5086 4.9443Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M10.2619 4.9443H11.2788C11.538 4.9443 11.7481 5.15442 11.7481 5.41363V6.43052C11.7481 6.68972 11.538 6.89985 11.2788 6.89985H10.2619C10.0027 6.89985 9.79256 6.68972 9.79256 6.43052V5.41363C9.79256 5.15442 10.0027 4.9443 10.2619 4.9443Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M5.73826 7.5517H4.72137C4.46216 7.5517 4.25203 7.76183 4.25203 8.02104V9.03793C4.25203 9.29713 4.46216 9.50726 4.72137 9.50726H5.73826C5.99746 9.50726 6.20759 9.29713 6.20759 9.03793V8.02104C6.20759 7.76183 5.99746 7.5517 5.73826 7.5517Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M7.49171 7.5517H8.5086C8.76781 7.5517 8.97793 7.76183 8.97793 8.02104V9.03793C8.97793 9.29713 8.76781 9.50726 8.5086 9.50726H7.49171C7.23251 9.50726 7.02238 9.29713 7.02238 9.03793V8.02104C7.02238 7.76183 7.23251 7.5517 7.49171 7.5517Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M11.2788 7.5517H10.2619C10.0027 7.5517 9.79256 7.76183 9.79256 8.02104V9.03793C9.79256 9.29713 10.0027 9.50726 10.2619 9.50726H11.2788C11.538 9.50726 11.7481 9.29713 11.7481 9.03793V8.02104C11.7481 7.76183 11.538 7.5517 11.2788 7.5517Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M4.72137 10.1591H5.73826C5.99746 10.1591 6.20759 10.3692 6.20759 10.6284V11.6453C6.20759 11.9045 5.99746 12.1147 5.73826 12.1147H4.72137C4.46216 12.1147 4.25203 11.9045 4.25203 11.6453V10.6284C4.25203 10.3692 4.46216 10.1591 4.72137 10.1591Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M8.5086 10.1591H7.49171C7.23251 10.1591 7.02238 10.3692 7.02238 10.6284V11.6453C7.02238 11.9045 7.23251 12.1147 7.49171 12.1147H8.5086C8.76781 12.1147 8.97793 11.9045 8.97793 11.6453V10.6284C8.97793 10.3692 8.76781 10.1591 8.5086 10.1591Z"
              fill={AppTheme.almostBlack}
          />
          <Path
              d="M14.4521 10.6667V11.2467L12.6388 15.3333H11.7121L13.4654 11.4H11.6321V12.1933H10.8254V10.6667H14.4521Z"
              stroke={AppTheme.almostBlack}
          />
      </Svg>
    </TouchableOpacity>
  );
}
